<template>
  <div>
    <div class="filter-table" style="width: 1040px;">
      <AutoComplete v-model="searchValue"
                    icon="ios-search"
                    placeholder="Search account"
                    style="width:300px"
                    :data="searchOptions"
                    :filter-method="filterMethod"
                    @on-change="filterAccounts">
      </AutoComplete>
      <Button type="primary" class="right" @click="exportData" ghost><Icon type="ios-download-outline"></Icon>Dump Accounts</Button>
    </div>
    <Table  ref="familyAccounts" :columns="columns" :data="filteredAccounts" width="1042" :loading="dataLoading">
      <div slot-scope="{ row }" slot="mailAddress">
        <strong>{{ row.mailAddress }}</strong>
      </div>
      <div slot-scope="{ row }" slot="validMail">
        <Badge status="success" class="valid-badge" v-if="row.validMail" />
        <Button type="primary" size="small"  v-else @click="validateMail(row)">Validate</Button>
      </div>
      <div slot-scope="{ row }" slot="maxWinkies" class="winky-container fit-to-content">
        <InputNumber class="winkies" :min="0" v-model="row.maxWinkies" @on-change="updateWinkies(row)"></InputNumber>
        <Spin v-show="showWinkyLoader && updatedId===row.id">
          <Icon type="ios-loading" size=14 class="spin-icon-load winky-loader"></Icon>
        </Spin>
      </div>
      <template slot-scope="{ row, index }" slot="action">
        <Button type="error" size="small" @click="remove(row)" style="margin-right: 5px">Delete</Button>
        <Button type="warning" size="small" @click="update(row,index)">Update</Button>
      </template>
    </Table>
  </div>
</template>

<script>
  import {bus} from "../../main";
  import { getFamilies, deleteFamily, updateFamily } from '../../_services/family.service'

  export default {
    data() {
      return {
        searchValue: null,
        searchOptions:[],
        columns: [
          {
            title: "Email",
            slot: "mailAddress",
            key: "mailAddress",
            width:250
          },
          {
            title: "Valid mail",
            slot: "validMail",
            key: "validMail",
            width: 120,
            align: "center"
          },
          {
            title: "Parental code",
            key: "parentalCode",
            align: "center",
            width: 140,
          },
          {
            title: "Max winkies",
            slot: "maxWinkies",
            key: "maxWinkies",
            align: "center",
            width: 150,
          },
          {
            title: "Preferred language",
            key: "preferredLanguage",
            align: "center",
            width: 170,
          },
          {
            title: " ",
            slot: "action",
            width: 210, //90
            align: "right"
          }
        ],
        familyAccounts:[],
        filteredAccounts:[],
        dataLoading:true,
        timeout: {},
        showWinkyLoader:false,
        updatedId:null,
        latestUpdated:null,
      };
    },
    methods: {
      getFamilyAccountsList() {
        getFamilies().then(res=>{
          this.familyAccounts = res.data.data;
          this.filteredAccounts = res.data.data;
          this.searchOptions = res.data.data.map(data=>{
            //for timeout
            this.timeout[data.id]=null
            return data.mailAddress
          })
          this.dataLoading = false
        }).catch(err => {
          this.dataLoading = false
          bus.$emit('requestError',err)
          this.$Message.error("Failed to get Family Accounts. Please try again later.");
        });
      },
      filterMethod (value, option) {
        if(value && option) {
          return option.toUpperCase().indexOf(value.toUpperCase()) !== -1;
        }else {
          return ""
        }
      },
      filterAccounts(val){
        this.filteredAccounts = this.familyAccounts.reduce((newAccounts,account)=>{
          if(account.mailAddress.indexOf(val)>-1){
            newAccounts.push(account)
          }
          return newAccounts
        },[])
      },
      updateWinkies(data){
        let vm=this
        clearTimeout(vm.timeout[data.id]);
        vm.timeout[data.id] = setTimeout(function () {
          let maxWinkies = data.maxWinkies
          if(!maxWinkies){
            maxWinkies=0
          }
          vm.showWinkyLoader=true
          vm.updatedId=data.id
          updateFamily(data.id, {MaxWinkies:maxWinkies}).then(res=>{
            vm.showWinkyLoader=false
            vm.updateOngoing=false
            vm.updatedId=null
            vm.$Notice.success({
              title: 'Updated max winkies',
              desc: `Successfully updated max winkies for ${data.mailAddress}.`,
            });
          }).catch(err=>{
            vm.getFamilyAccountsList()
            vm.showWinkyLoader=false
            vm.updatedId=null
            vm.$Notice.error({
              title: 'Failed to update',
              desc: `Failed to update max winkies for ${data.mailAddress}.`,
            });
          })
        }, 1000);
      },
      remove(data){
        let confirmMessage = `<p>Are you sure you want to remove ${data.mailAddress}?</p>`
        if(data.winkies.length || data.members.length){
          confirmMessage += `<p>It will also delete all related Games, Authors, Winkies, etc. from the database.</p>`
        }
        this.$Modal.confirm({
          title: 'Remove Family account',
          content: confirmMessage,
          okText: 'Remove',
          cancelText: 'Cancel',
          onOk: () => {
            this.dataLoading = true
            deleteFamily(data.id).then(res => {
              this.getFamilyAccountsList();
              this.dataLoading = false
              this.$Message.success(`Account ${data.mailAddress}  successfully deleted!`);
            }).catch(err => {
              this.dataLoading = false
              this.$Message.error("Failed to remove account. Please try again later.");
            });
          },
        });
      },
      validateMail(data){
        let vm=this

        let confirmMessage = `<p>Continue validating mail address: <b>${data.mailAddress}</b>?</p>`

        this.$Modal.confirm({
          title: 'Validate Mail Address',
          content: confirmMessage,
          okText: 'Validate',
          cancelText: 'Cancel',
          onOk: () => {
            updateFamily(data.id, {ValidMail:true})
            .then(res=>{  
                vm.showWinkyLoader=false
                vm.updateOngoing=false
                vm.updatedId=null
                vm.$Notice.success({
                  title: 'Validated mail address',
                  desc: `Successfully validated mail address: <b>${data.mailAddress}</b>.`,
                });
                vm.getFamilyAccountsList()
            })
            .catch(err=>{
                vm.getFamilyAccountsList()
                vm.showWinkyLoader=false
                vm.updatedId=null
                vm.$Notice.error({
                  title: 'Failed to validate',
                  desc: `Failed to validate Mail address :<b>${data.mailAddress}</b>.`,
                });
            })
          },
        });
      },
      update: async function(data,index) {
        this.latestUpdated=index
        this.$emit("update", data);
      },
      exportData () {
          this.$refs.familyAccounts.exportCsv({
            filename: 'family_accounts',
            original: false
          });
      }
    },
    mounted() {
      this.getFamilyAccountsList()
    }
  };
</script>
<style>
  .valid-badge .ivu-badge-status-dot{
    width: 8px;
    height: 8px;
    margin: 0 auto;
  }
  .winkies{
    width: 40px!important;
  }
  .winkies .ivu-input-number-input{
    text-align: center;
  }
  .ivu-table-row-hover .winkies:not(.ivu-input-number-disabled) .ivu-input-number-input{
    text-align: left;
  }
  .winkies.ivu-input-number-disabled,.winkies.ivu-input-number-disabled .ivu-input-number-input {
    background-color:#FFFFFF;
    color: initial;
  }
  .ivu-table-row-hover .winkies:not(.ivu-input-number-disabled){
    width: 60px!important;
  }
  .ivu-table-row-hover .winkies .ivu-input-number-handler-wrap{
    opacity: 1;
  }
  .winky-container{
    position: relative;
  }
  .winky-loader{
    position: absolute;
    top:10px;
    right: -20px;
  }
</style>
